import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Button,
  Box,
  Pagination,
  Checkbox,
  Backdrop,
  CircularProgress
} from '@mui/material';
import OurLayouts from '../Layouts';
import apiService from '../../services/apiservice';
import { Sidebar } from "primereact/sidebar";
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import { FaFilter } from 'react-icons/fa';
import { InputText } from 'primereact/inputtext';
import PatientSearch from '../Shared/patientSearch';
import { Dropdown } from "primereact/dropdown";
import { toast } from 'react-toastify';

const STATUS_OPTIONS = [
  { id: 6, value: 'Approved' },
  { id: 5, value: 'Rejected' },
];

const STATUS_MAP = {
  0: "Rejected",
  1: "Under Process",
  2: "Discussing with Hospital",
  3: "Discussing with Patient",
  4: "Patient Denied",
  5: "Hospital Denied",
  6: "Procedure Confirmed",
  7: "Hold",
  11: "New",
  12: "Waiting For Approval"
};

const STATUS_COLORS = {
  1: '#ECAC09',
  2: '#ECAC09',
  3: '#ECAC09',
  7: '#ECAC09',
  0: '#DD0000',
  4: '#DD0000',
  5: '#DD0000',
  6: '#299F5D',
  8: '#299F5D',
  9: '#299F5D',
  11: '#3D3BA4',
  12: '#3D3BA4'
};

const ITEMS_PER_PAGE = 10;

const PracticeAdmin = () => {
  const userObj = JSON.parse(localStorage.getItem('loginObj') || '{}');
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [enquiryList, setEnquiryList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selected, setSelected] = useState({});
  const [viewEnquiry, setViewEnquiry] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [patientSearchSidebar, setPatientSearchSidebar] = useState(false);
  const [totalPage, setTotalPage] = useState(0);

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  };

  const getStyleStatus = useCallback((statusCode) => ({
    border: '1px solid',
    borderColor: STATUS_COLORS[statusCode] || 'black',
    padding: '5px',
    color: STATUS_COLORS[statusCode] || 'black',
    display: 'inline-block',
    borderRadius: '5px'
  }), []);

  const toggleSidebarFilter = useCallback(() => {
    setPatientSearchSidebar(prev => !prev);
  }, []);

  const handleSelectedData = useCallback((e) => {
    setFilterObj(prev => ({
      ...prev,
      patientId: e.code,
      patientName: e.name,
      nameSearch: ""
    }));
  }, []);

  const handleChangeTab = useCallback((tab) => {
    setFilterObj({});
    setSelected({});
    setActiveTab(tab);
    setCurrentPage(1);
  }, []);

  const handlePageChange = useCallback((event, value) => {
    setCurrentPage(value);
  }, []);

  const handleCheckboxChange = useCallback((id) => {
    setSelected(prev => ({
      ...prev,
      [id]: !prev[id],
    }));
  }, []);

  const handleSelectAll = useCallback((event) => {
    const isChecked = event.target.checked;
    const newSelected = {};
    enquiryList.forEach((notifi) => {
      newSelected[notifi.id] = isChecked;
    });
    setSelected(newSelected);
  }, [enquiryList]);

  const handleChangeFilter = useCallback((e) => {
    const { name, value } = e.target;
    
    if (name === "fromDate" || name === "toDate") {
      setFilterObj(prev => ({
        ...prev,
        [name]: formatDate(value),
      }));
    } else if (name === "nameSearch" && value) {
      setFilterObj(prev => ({
        ...prev,
        [name]: value,
        patientId: "",
        patientName: ""
      }));
    } else {
      setFilterObj(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  }, []);

  const getEnqList = useCallback(async () => {
    const res = await apiService.userInfoAll(userObj.user.code);
    const payload = {};
    debugger
    try {
      payload.status = 12;
      payload.pageNumber = currentPage;
   payload.hospitalId = res?.data?.successList
        ?.map(item => item.hospitalId)
        .join(',');      payload.tab = 1;
      console.log( payload.hospitalId)
      setLoading(true);
      
      if (activeTab === 1) {
        payload.statusFlag = 1;
      }
      if (activeTab === 1) {
        delete payload.status;
      }
      if (filterObj.id) {
        payload.id = filterObj.id;
      }
      if (filterObj.patientId) {
        payload.patientId = filterObj.patientId;
      }
      if (filterObj.fromDate) {
        payload.fromDate = filterObj.fromDate;
      }
      if (filterObj.toDate) {
        payload.toDate = filterObj.toDate;
      }
      if (filterObj.status) {
        payload.status = filterObj.status;
        delete payload.statusFlag;
      }
      if (filterObj.nameSearch) {
        payload.nameSearch = filterObj.nameSearch;
      }

      const result = await apiService.getenqList(payload);
      if (result.data.responseCode === '200') {
        setLoading(false);
        setTotalPage(Math.ceil(result.data.pagination.totalRecords / ITEMS_PER_PAGE));
        setEnquiryList(result.data.successList);
      }
    } catch (error) {
      console.error('Error fetching enquiry list:', error);
      setLoading(false);
    }
  }, [userObj.user.code, currentPage, activeTab, filterObj]);

  const handleAction = useCallback(async (data, tab) => {
    const payload = [{
      modifiedBy: userObj.user.code,
      modifiedDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      status: tab === "A" ? 6 : 5,
      id: data.id,
      publishStatus: tab === "A" ? "A" : "R"
    }];
    
    const result = await apiService.enquiryStatusUpdate(payload);
    if (result) {
      const message = tab === "A" ? "Approved successfully" : "Rejected successfully";
      toast(message);
      getEnqList();
    }
  }, [userObj.user.code, getEnqList]);

  const handleActionAll = useCallback(async (tab) => {
    const selectedrow = enquiryList.filter(item => selected[item.id]);
    if (selectedrow.length > 0) {
      const payload = selectedrow.map(item => ({
        id: item.id,
        modifiedBy: userObj.user.code,
        modifiedDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        status: tab === "A" ? 6 : 5,
      }));
      const result = await apiService.enquiryStatusUpdate(payload);
      if (result) {
        const message = tab === "A" ? "Approved successfully" : "Rejected successfully";
        toast(message);
        getEnqList();
      }
    } else {
      toast("Nothing selected");
    }
  }, [enquiryList, selected, userObj.user.code, getEnqList]);

  const handleClickFilter = useCallback(() => {
    setViewEnquiry(true);
  }, []);

  const filterService = useCallback(() => {
    setViewEnquiry(false);
    setCurrentPage(1);
    getEnqList();
  }, [getEnqList]);

  const handleCancel = useCallback(() => {
    setFilterObj({});
  }, []);

  useEffect(() => {
    getEnqList();
  }, [activeTab, currentPage, getEnqList]);

  const selectedCount = useMemo(() => 
    Object.keys(selected).filter(key => selected[key]).length, 
    [selected]
  );

  const isAllSelected = useMemo(() => 
    enquiryList.length > 0 && enquiryList.every(item => selected[item.id]), 
    [enquiryList, selected]
  );

  const sidebarFooter = (
    <div className="grid mt-36 ml-3 grid-cols-2">
      <div>
        <button 
          className="h-9 bg-[#004172] text-white rounded-md w-full"
          onClick={filterService}
        >
          Ok
        </button>
      </div>
      <div>
        <button 
          className="ml-3 h-9 border border-[#004172] text-[#004172] font-bold font-monospace rounded-md w-full"
          onClick={handleCancel}
        >
          Clear
        </button>
      </div>
    </div>
  );

  const renderFilterSidebar = (
    <Sidebar 
      style={{ width: '45%', borderBottom: '1px solid #ccc' }} 
      dismissable={false}
      visible={viewEnquiry} 
      header={"Filter Service"} 
      centered={true}
      onHide={() => setViewEnquiry(false)} 
      position="right"
    >
      <div className="grid mt-4 grid-cols-2 gap-4">
        <div>
          <label htmlFor="dob">From Date</label>
          <Calendar 
            id="date"
            className="border border-gray-300 rounded-md p-2 w-full" 
            dateFormat="dd/mm/yy" 
            style={{ height: '40px' }}
            onChange={handleChangeFilter} 
            name='fromDate' 
            value={parseDate(filterObj.fromDate)} 
            placeholder="Select From Date"
          />
        </div>
        <div>
          <label htmlFor="dob">To Date</label>
          <Calendar 
            id="date"
            className="border border-gray-300 rounded-md p-2 w-full" 
            dateFormat="dd/mm/yy" 
            style={{ height: '40px' }}
            onChange={handleChangeFilter} 
            name='toDate' 
            value={parseDate(filterObj.toDate)} 
            placeholder="Select To Date"
          />
        </div>
        <div>
          <label htmlFor="nameSearch">Patient Name</label>
          <div className="relative">
            <input
              id="nameSearch"
              name="nameSearch"
              className="border border-gray-300 rounded-md p-2 pr-10 w-full"
              onChange={handleChangeFilter}
              value={filterObj.nameSearch || ''}
              placeholder="Search by patient name"
              type="text"
            />
          </div>
        </div>
        <div>
          <label htmlFor="emailId">Select Patient</label>
          <div className="relative">
            <InputText 
              id="patientName" 
              className="border border-gray-300 rounded-md p-2 pr-10 w-full" 
              value={filterObj.patientName || ''} 
              name="patientName" 
              placeholder="Click icon to search patients" 
              readOnly 
            />
        <button
  type="button"
  className="absolute inset-y-0 right-0 flex items-center pr-2"
  onClick={toggleSidebarFilter}
  aria-label="Toggle sidebar filter"
>
  <svg
    className="w-5 h-5 text-gray-400"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path d="M21 21l-5.2-5.2"></path>
    <circle cx="10" cy="10" r="7"></circle>
  </svg>
</button>

          </div>
        </div>
        <div>
          <label htmlFor="id">Enquiry Id</label>
          <div className="relative">
            <InputText 
              id="id" 
              name="id" 
              className="border border-gray-300 rounded-md p-2 pr-10 w-full"
              onChange={handleChangeFilter}
              value={filterObj.id || ''} 
              placeholder="Search for Enquiry Id" 
            />
          </div>
        </div>
        {activeTab === 1 && (
          <div>
            <label htmlFor="status">Status</label>
            <Dropdown
              value={filterObj.status || ''}
              options={STATUS_OPTIONS}
              optionLabel="value"
              placeholder="Select Status"
              optionValue='id'
              name='status'
              className="border border-gray-300 rounded-md w-full"
              onChange={handleChangeFilter}
              filter
            />
          </div>
        )}
      </div>
      {sidebarFooter}
    </Sidebar>
  );

  const renderTableHeader = (
    <TableHead>
      <TableRow>
        {activeTab === 0 && (
          <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>
            <div style={{ width: 'max-content' }}>
              Select All <Checkbox
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
            </div>
          </TableCell>
        )}
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry ID</TableCell>
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient ID</TableCell>
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Patient Name</TableCell>
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Enquiry Date</TableCell>
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Mobile Number</TableCell>
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Hospital Name</TableCell>
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>Procedure</TableCell>
        <TableCell style={{ fontSize: '17px', fontWeight: 600, width: '200px' }}>Status</TableCell>
        {activeTab === 0 && (
          <TableCell style={{ fontSize: '17px', fontWeight: 600, width: '200px' }}>Action</TableCell>
        )}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = enquiryList.map((notifi) => (
    <TableRow key={notifi.id}>
      {activeTab === 0 && (
        <TableCell style={{ fontSize: '17px', fontWeight: 600 }}>
          <Checkbox
            checked={selected[notifi.id] || false}
            onChange={() => handleCheckboxChange(notifi.id)}
          />
        </TableCell>
      )}
      <TableCell style={{ fontSize: '17px', fontWeight: 500 }}>
        {notifi.id}
      </TableCell>
      <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
        {notifi.patientId}
      </TableCell>
      <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
        {notifi.patientName}
      </TableCell>
      <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
        <div style={{ width: 'max-content' }}>
          {moment(notifi.createdDate).format("DD-MM-YYYY HH:mm:ss")}
        </div>
      </TableCell>
      <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
        {notifi.patientContactNumber || ''}
      </TableCell>
      <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
        {notifi.hospitalName}
      </TableCell>
      <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
        {notifi.procedureName}
      </TableCell>
      <TableCell style={{ fontSize: "15px", fontWeight: 500, width: "200px" }}>
        <span style={getStyleStatus(notifi.status)}>
          {STATUS_MAP[notifi.status] || ""}
        </span>
      </TableCell>
      {activeTab === 0 && (
        <TableCell style={{ fontSize: '12px', fontWeight: 500 }}>
          <div className="">
            <button 
              className="h-9 w-28 bg-[#004172] text-white rounded-md w-full"
              onClick={() => handleAction(notifi, "A")}
            >
              Approve
            </button>
            <button 
              className="mt-1 w-28 h-9 border border-[#004172] bg-[#fff] text-black rounded-md w-full"
              onClick={() => handleAction(notifi, "R")}
            >
              Reject
            </button>
          </div>
        </TableCell>
      )}
    </TableRow>
  ));

  return (
    <>
      <OurLayouts>
        <Backdrop
          sx={{ color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress size={80} color="inherit" />
        </Backdrop>
        
        {renderFilterSidebar}
        
        <div className="flex flex-col w-full mt-[7rem] overflow-auto">
          <div className="flex justify-between mt-[3rem]">
            <div>
              <h1 className="text-2xl text-primary font-semibold">Patient Approval</h1>
            </div>
            <div className='flex border h-10 rounded-md pt-1 pb-1 mr-12 justify-items-center'>
              <div className='flex mx-2'>
                <Button 
                  className='flex gap-1'
                  onClick={handleClickFilter}
                >
                  <FaFilter className='text-primary' />
                  <h6 className='text-primary'>Filter</h6>
                </Button>
              </div>
            </div>
          </div>
          
          {selectedCount > 0 && (
            <div className="flex flex-end justify-end mt-4 mr-4">
              <div className="">
                <button 
                  className="h-9 p-2 bg-[#004172] text-white rounded-md w-full"
                  onClick={() => handleActionAll("A")}
                >
                  Approve Selected
                </button>
              </div>
              <div className="">
                <button 
                  className="ml-2 p-2 h-9 border border-[#004172] bg-[#fff] text-black rounded-md w-full"
                  onClick={() => handleActionAll("R")}
                >
                  Reject Selected
                </button>
              </div>
            </div>
          )}
          
          <div 
            className="w-[99%] mt-8 rounded-[5px]" 
            style={{ boxShadow: "0px 8px 25px 0px rgba(0, 0, 0, 0.06)" }}
          >
            <Tabs 
              value={activeTab} 
              onChange={(event, newValue) => handleChangeTab(newValue)}
            >
              <Tab label={<span style={{ fontWeight: 'bold' }}>Assign To Me</span>} />
              <Tab label={<span style={{ fontWeight: 'bold' }}>ALL</span>} />
            </Tabs>
            
            <TableContainer 
              component={Paper} 
              className="print-table" 
              style={{ width: '100%', overflowX: 'auto' }}
            >
              <Table>
                {renderTableHeader}
                <TableBody>
                  {renderTableBody}
                </TableBody>
              </Table>
            </TableContainer>
            
            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
              <Pagination
                count={totalPage}
                page={currentPage}
                color="secondary"
                onChange={handlePageChange}
              />
            </Box>
          </div>
        </div>
      </OurLayouts>
      
      <PatientSearch
        showbar={patientSearchSidebar}
        setshowBar={toggleSidebarFilter}
        onSelect={handleSelectedData}
      />
    </>
  );
};

export default PracticeAdmin;